module.exports = __webpack_public_path__ + "static/media/laurel_line.d681d9d7.svg";